import React from 'react';
import { useSelector } from 'react-redux';
import { getLocalString, localNames } from 'utils/localisation.service';

const UploadTitle = () => {
  const locales = useSelector(state => state.forms?.localeStrings);
  return (
    <div className="custom-drag__title">
      {getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS_DRAGANDDROP)}
    </div>
  );
};

export default UploadTitle;
